const lastVisitedKey = "lastVisited";
const currentLocationKey = "userLocation";

let userFavorites = null;

export const readCurrentLocationFromStorage = () => {
    try {
        const locationString = localStorage.getItem(currentLocationKey);
        const location = JSON.parse(locationString);
        // Check if location object is correct
        if (location?.country_name &&
            location?.name &&
            location?.location_id) {
            return location;
        } else {
            localStorage.removeItem(currentLocationKey);
            return null;
        }
    } catch {
        console.error("No localstorage access");
    }

    return null;
}

export const clearCurrentLocationFromStorage = () => {
    try {
        localStorage.removeItem(currentLocationKey);
    }
    catch {
        console.error("No localstorage access");
    }
}

export const addCurrentLocationToStorage = (location) => {
    try {
        localStorage.setItem(currentLocationKey, JSON.stringify(location));
    }
    catch {
        console.error("No localstorage access")
    }
}

export const addLastVisitedToStorage = (newLocation) => {
    try {
        if (!newLocation) return null;
        if (newLocation.name === null) return null;
        const locationsString = localStorage.getItem(lastVisitedKey);
        const list = JSON.parse(locationsString);
        const newList = list ?? [];
        const index = findItemIndex(newLocation, newList);

        // Move most recent location to the bottom
        if (index >= 0 && index != null) {
            newList.push(newList.splice(index, 1)[0]);
        } else {
            newList.push(newLocation);
        }

        if (newList.length >= 7) {
            newList.shift();
        }

        localStorage.setItem(lastVisitedKey, JSON.stringify(newList));
    } catch (e) {
        console.error("No localstorage access")
    }
    return null;
}

export const readLastVisitedFromStorage = () => {
    try {
        const locationsString = localStorage.getItem(lastVisitedKey);
        const locations = JSON.parse(locationsString);
        // Check if location object is correct
        if (locations) {
            return locations;
        } else {
            localStorage.removeItem(lastVisitedKey);
            return null;
        }
    } catch {
        console.error("No localstorage access")
    }

    return null;
}

export const clearLastVisited = () => {
    try {
        localStorage.removeItem(lastVisitedKey);
    } catch {
        console.error("No localstorage access")
    }
}

export const getFavoritesList = async () => {
    if (userFavorites) {
        return userFavorites
    }
    const userData = await window.auth.getUserData();
    if (userData && userData.length) {
        userFavorites = userData;
        return userData;
    } else {
        return null;
    }
};

export const addtoFavoritesList = async (location) => {
    
    if (!location) return null;
    if (location.name === null) return null;

    // Make sure there are no country or region lists
    delete location.country_lists;
    delete location.region_lists;

    const list = await getFavoritesList();
    const newList = list ?? [];
    const index = findItemIndex(location, newList);

    if (index >= 0 && index != null) {
        newList.push(newList.splice(index, 1)[0]);
    } else {
        newList.push(location);
    }

    // clear previous userFavorites
    userFavorites = null;

    // Write to kv storage
    const result = await window.auth.setUserData(newList);
    if (result?.status >= 200 && result?.status < 300) {
        return newList
    }
    return null;
};

export const removefromFavoritesList = async (location) => {
    if (!location) return null;
    const list = await getFavoritesList();
    const newList = list ?? [];
    const index = findItemIndex(location, newList);
    if (index != null) {
        newList.splice(index, 1);
    }
    // clear previous userFavorites
    userFavorites = null;

    // Write to kv storage
    const result = await window.auth.setUserData(newList);
    if (result?.status >= 200 && result?.status < 300) {
        return newList
    }
    return null;
}

const findItemIndex = (location, list) => {
    if (!list || !location) return null;
    return list?.findIndex((item) => item?.tracking_id === location?.tracking_id);
};